// 创建node的动作类型
export const CREATE_ACTIONS = {
  menuToCreate: 'MENUTOCREATE', // 从左侧栏创建
  copyTextToCreate: 'COPYTEXTTOCREATE', // 复制文字创建
  copyNodeToCreate: 'COPYNODETOCREATE' // 复制节点创建
}
